<template>
    <!-- 集中檢核 資料與他人重複提示燈箱 -->
    <PopupBase
        v-model:visiblePopup="visibleCheckPopup"
        modalWidth="max-w-[90%] sm:max-w-[30rem]"
        :params="{
            title: '驗證Email',
            cancelButton: '取消',
            confirmButton: '確定',
        }"
        closeicon
        @handleClose="closePopup"
        @cancel="closePopup"
    >
        <template #content>
            <ul class="space-y-2 list-decimal ml-6 mb-4">
                <li>
                    系統將於1~2分鐘內傳送動態密碼予您。
                </li>
                <li>
                    系統將於1~2分鐘內傳送動為確保個人資料安全性，此動態密碼自發送後起5分鐘內有效。
                </li>
            </ul>
            <div class="flex flex-col xs:flex-row items-center justify-between space-x-2 space-y-2">
                <p class="break-all text-lg">
                    XXXXX@XXXXXXXXXXXXXXXX.CCCCCCC
                </p>
                <button class="btn rounded-md min-w-[7.5rem] sm:ml-2 lowercase mb-2 gradient-primary">
                    發送驗證碼
                </button>
            </div>
            <h4 class="mt-5 mb-1">
                請輸入6碼驗證碼
            </h4>
            <input
                v-model="inputValue"
                class="input-base xs:max-w-[17rem]"
                inputmode="numeric"
                autocomplete="off"
                maxlength="6"
                type="text"
                placeholder="請輸入驗證碼"
            >
        </template>
    </PopupBase>
</template>

<script>
import { ref, watch } from 'vue';
import PopupBase from '@/components/dialogs/Popup.vue';

export default {
    components: {
        PopupBase,
    },
    props: {
        isPopup: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:isPopup'],
    setup(props, { emit }) {
        const checkBDPMessage = ref('');
        const visibleCheckPopup = ref(false);

        /** 資料燈箱關閉 */
        const closePopup = () => {
            emit('update:isPopup', false);
        };

        /** 確認輸入資料是否與他人重複 */
        watch(() => props.isPopup, (newV) => {
            visibleCheckPopup.value = newV;
        }, { immediate: true, deep: true });

        return {
            checkBDPMessage,
            closePopup,
            visibleCheckPopup
        };
    },
};
</script>
